class FaviconNotification {
    constructor(faviconArray, itemsCount) {
        this.favicon = document.querySelector('[data-favicon]');
        this.defaultFavicon = this.favicon.href;

        this.title = document.querySelector('title');
        this.defaultTitle = this.title.textContent;

        this.faviconArray = faviconArray;
        this.cartItemsCount = itemsCount;


        this.visibilityChangeHandle = this.visibilityChangeHandle.bind(this);
        this.setCartCount();
        this.bindEvents();
    }
    bindEvents() {
        document.addEventListener("visibilitychange", this.visibilityChangeHandle);
    }
    visibilityChangeHandle() {
        const TITLEMESSAGE = 'Don’t forget this...';
        if (document.hidden) {
            this.title.textContent = TITLEMESSAGE;
        } else {
            this.title.textContent = this.defaultTitle;
        }
    }
    setCartCount(itemsCount = this.cartItemsCount) {
        // Util
        const setHref = (file) => {
            this.favicon.setAttribute('href', file)
        }
        this.cartItemsCount = itemsCount;

        // Limit handles: >=10 and 0 
        if (this.cartItemsCount >= 10) {
            setHref(this.faviconArray.slice(-1));
            return;
        } else if (this.cartItemsCount === 0) {
            setHref(this.defaultFavicon)
            return;
        }

        //General
        setHref(this.faviconArray[itemsCount - 1]);
    }
}